/**
 * External dependencies
 */
import { get } from 'lodash';

export default (state, id) => get(state, ['locationGroups', 'items', id], null);